import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lesson from "./Lesson";
import Layout from "./Layout";
import Feedback from "./Feedback";
import Stats from "./Stats";
import lessons from "../lessons/german";
import videoTitles from "../videoTitles.json";
import Search from "./Search";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout lessons={lessons} />}>
          <Route index element={<Lesson lesson={lessons[1]} />} />
          <>
            {lessons.map((lesson) => (
              <Route
                path={`lesson${lesson.num}`}
                element={<Lesson lesson={lesson} />}
              />
            ))}
          </>
          <Route path={`lesson${lessons.length}`} element={<Feedback />} />
          <Route path="editor" element={<Search />} />
          <>
            {videoTitles.map((title) => (
              <Route
                path={title[0].toLowerCase()}
                element={
                  <Stats
                    title={title[1]}
                    video={require(`../transcripts/${title[0]}.json`)}
                  />
                }
              />
            ))}
          </>
          <Route path="*" element={<Lesson lesson={lessons[1]} />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
